import { SearchFilterTag } from '@/components';
import { AccountingTypeLabelModifier } from '@/features/master-table/models';
import type { AnalysisSearchFormType } from '@/features/search/_models/analysis-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const AccountingTypeTag: FC = () => {
  const { t } = useTranslation();

  const { control: sharedSearchControl, setValue: setSharedSearchValue } =
    useFormContext<SharedSearchFormType>();
  const { control: projectSearchControl } =
    useFormContext<AnalysisSearchFormType>();

  const [sheetType, accountingType] = useWatch({
    control: sharedSearchControl,
    name: ['sheetType', 'accountingType'],
  });

  const analysisTarget = useWatch({
    control: projectSearchControl,
    name: 'analysisTarget',
  });

  if (sheetType !== 'RS' || !accountingType || analysisTarget === 'payment') {
    return null;
  }

  const value = AccountingTypeLabelModifier[accountingType];

  return (
    <SearchFilterTag
      closable={true}
      label={`${t('accounting-type')}: ${value}`}
      onClose={() => {
        setSharedSearchValue('accountingType', null);
        setSharedSearchValue('accountingTypeIds', null);
      }}
    />
  );
};
